/**
 * Apply the Design System to a single Drupal behavior
 */

// ECMAScript polyfills, but NOT fetch(). Fetch() is web standard, not ECMAScript.
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { enableAllComponents } from '../../source/default';

require('./scss/_drupal-styles.scss');

Drupal.behaviors.designSystem = {
  attach($context, settings) {
    enableAllComponents($context, settings);
  },
};
